import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export function useAcknowledgeGpsAlert(companyId: string) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (alertId: string) => {
      const { data: { user } } = await supabase.auth.getUser();
      
      const { data, error } = await (supabase as any)
        .from('fleet_gps.alert_events')
        .update({
          ack_at: new Date().toISOString(),
          ack_by: user?.id,
        })
        .eq('id', alertId)
        .eq('company_id', companyId)
        .select()
        .single();
      
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gps-alert-events', companyId] });
      toast({
        title: "Alerta GPS reconhecido",
        description: "O alerta foi marcado como reconhecido.",
      });
    },
    onError: (error) => {
      console.error('Error acknowledging GPS alert:', error);
      toast({
        variant: "destructive",
        title: "Erro ao reconhecer alerta",
        description: "Não foi possível reconhecer o alerta GPS.",
      });
    },
  });
}
